<template>
    <div class="c-jhs-free-lp-accordion">
        <div id="precaution" class="c-jhs-free-lp-accordion-back_dark_gray c-jhs-free-lp-accordion-heading">
            <img :src="buildImgUrl('accordion_heading.png')" alt="サービス詳細とご注意事項">
        </div>
        <details class="c-jhs-free-lp-accordion-item" :open="'open'">
            <summary class="c-jhs-free-lp-accordion-title c-jhs-free-lp-accordion-back_gray">
                <img :src="buildImgUrl('accordion_title_01.png')" alt="サービス内容について">
            </summary>
            <div class="c-jhs-free-lp-accordion-content">
                <p class="is-mgb16">
                    ▼申込および無料化対象期間<br>
                    <span v-if="!isAfter20260401" data-jest="before-20260401-text">
                        2025年度中3<br>
                        申込期間：2026年2月20日まで<span class="is-caution" data-jest="before-20260401-text-01">※終了しました</span><br>
                        無料化期間：審査完了後～2026年2月末日<br>
                        2025年度中2<br>
                        申込期間：2027年2月20日まで<br>
                        無料化期間：審査完了後～2027年2月末日<br>
                        2025年度中1<br>
                        申込期間：2028年2月20日まで<br>
                        無料化期間：審査完了後～2028年2月末日<br>
                    </span>
                    <span v-else data-jest="after-20260401-text">
                        2026年度中3<br>
                        申込期間：2027年2月20日まで<br>
                        無料化期間：審査完了後～2027年2月末日<br>
                        2026年度中2<br>
                        申込期間：2028年2月20日まで<br>
                        無料化期間：審査完了後～2028年2月末日<br>
                        2026年度中1<br>
                        申込期間：2029年2月20日まで<br>
                        無料化期間：審査完了後～2029年2月末日<br>
                    </span>
                    ※審査で利用可能と判断された方のみご利用頂けます。
                </p>
                <p class="is-mgb16">
                    ▼申込条件<br>
                    以下のすべての条件を満たすお客様が対象となります。<br>
                    <span v-if="!isAfter20260401" data-jest="before-20260401-text">①2011年4月2日～2013年4月1日生まれの方</span>
                    <span v-else data-jest="after-20260401-text">①2011年4月2日～2014年4月1日生まれの方</span>
                    <br>
                    ②ピクトリンクの無料会員になっている方<br>
                    ③指定の本人確認書類をご提出いただける方
                </p>
                <p class="is-mgb16">
                    ▼サービス内容<br>
                    無料でピクトリンクのプレミアム会員が利用できるサービスです。
                </p>
                <p>
                    プレミアム会員のサービス内容<br>
                    ①撮影したプリの画像を全て保存できる<br>
                    ②らくがきなしプリも保存できる<br>
                    ③保存したプリの画像を、ピクトリンク上に保管できる<br>
                    ※サービス期間終了後は自動的に「無料会員」になります。自動で課金されることはありません。<br>
                    ※現在ご自身でプレミアム会員登録されている方は課金を解約することをお勧めします。<br>
                    ※プリの撮影には別途料金が必要です。<br>
                    ※本サービスは都合により、期間中であっても新規受付を終了させていただく場合がございます。
                </p>
            </div>
        </details>
        <details class="c-jhs-free-lp-accordion-item" :open="'open'">
            <summary class="c-jhs-free-lp-accordion-title c-jhs-free-lp-accordion-back_gray">
                <img :src="buildImgUrl('accordion_title_02.png')" alt="申し込みに関する注意事項">
            </summary>
            <div class="c-jhs-free-lp-accordion-content">
                <list-text>
                    <li class="m-list-text-item">本サービスへのお申し込みはおひとり様一回限りとなります。<br>
                        ※審査において再申し込みが必要と判断された方のみ再申し込みが可能です。</li>
                    <li class="m-list-text-item">審査には5日かかる場合がございます。やむを得ない事情で5日以上かかる場合もございます。</li>
                    <li class="m-list-text-item">審査を通過された方でも、その後本人確認書類が偽造、あるいは本人以外のものであったり、対象の生年月日に該当しないことが発覚した場合にはプレミアム会員の権利を剥奪（はくだつ）する場合があります。また、無料化期間分のプレミアム会員料金を請求する場合があります。</li>
                    <li class="m-list-text-item">お申込みの際は、本サービス内容について保護者の同意を得た上でお申込みください。お申込みいただいた段階で、保護者の同意を得ているものとみなします。</li>
                    <li class="m-list-text-item">機種・OS・ブラウザ等の理由により、一部のパソコン、スマートフォン、タブレット等でお申込みいただけない場合もございます。</li>
                    <li class="m-list-text-item">インターネット接続が十分に確保されている状態でご応募ください。申し込みの途中でインターネット接続が途切れてしまった場合には、申し込みが無効となることがございます。</li>
                </list-text>
            </div>
        </details>
        <details class="c-jhs-free-lp-accordion-item" :open="'open'">
            <summary class="c-jhs-free-lp-accordion-title c-jhs-free-lp-accordion-back_gray">
                <img :src="buildImgUrl('accordion_title_03.png')" alt="本人確認書類の提出について">
            </summary>
            <div class="c-jhs-free-lp-accordion-content">
                <list-text>
                    <li class="m-list-text-item">本人確認書類は、中学生であることが証明できる書類以外の提出は不可となります。</li>
                    <li class="m-list-text-item">上記の本人確認書類が提出できない場合は、申し込みはできません。</li>
                    <li class="m-list-text-item">不鮮明な画像や全面が写っておらず一部欠けている画像など、不備がある場合は年齢確認ができず、審査が通らない場合があります。</li>
                    <li class="m-list-text-item">本人確認書類について、必ず原本を撮影してください。コピー、期限切れ、使用不可の細工が施してある物は不可となります。</li>
                </list-text>
            </div>
        </details>
        <details class="c-jhs-free-lp-accordion-item" :open="'open'">
            <summary class="c-jhs-free-lp-accordion-title c-jhs-free-lp-accordion-back_gray">
                <img :src="buildImgUrl('accordion_title_04.png')" alt="保護者の方へ">
            </summary>
            <div class="c-jhs-free-lp-accordion-content">
                <p class="is-mgb16">
                    ▼ピクトリンクを運営するフリュー株式会社について<br>
                    2007年4月にオムロングループから独立。「人々のこころを豊かで幸せにする良質なエンタテインメントを創出する！」という企業理念のもと事業を積み上げ、2015年に東京証券取引所市場へ上場しております。<br>
                    フリュー株式会社についての詳細は<link-text :link="furyuUrl" :new-window="true" text="こちら" data-jest="furyu-link"/>よりご確認ください。
                </p>
                <p class="is-mgb16">
                    ▼ピクトリンクの運営方針について<br>
                    フリュー株式会社はピクトリンクの運営に当たり、青少年の主体性を確保しつつ違法・有害情報から保護することの重要性を認識し、健全化に資する運用方針を定めております。<br>
                    詳しくは<link-text :link="operatingPolicyUrl" :new-window="true" text="こちら" data-jest="operating-policy-link"/>よりご確認ください。
                </p>
                <p>
                    ▼今回の申し込みでご提出頂く個人情報について<br>
                    今回ご入力いただく名前、生年月日、本人確認書類は年齢確認審査に利用します。<br>
                    個人情報保護方針については<link-text :link="privacyUrl" :new-window="true" text="こちら" data-jest="privacy-link"/>
                </p>
            </div>
        </details>
        <details id="questions" class="c-jhs-free-lp-accordion-item" :open="'open'">
            <summary class="c-jhs-free-lp-accordion-title c-jhs-free-lp-accordion-back_gray">
                <img :src="buildImgUrl('accordion_title_05.png')" alt="よくある質問">
            </summary>
            <div class="c-jhs-free-lp-accordion-content">
                <p>
                    よくある質問は<link-text :link="helpTopUrl" :new-window="true" text="こちら" data-jest="help-link"/>からご確認ください。
                </p>
            </div>
        </details>
        <details class="c-jhs-free-lp-accordion-item" :open="'open'">
            <summary class="c-jhs-free-lp-accordion-title c-jhs-free-lp-accordion-back_gray">
                <img :src="buildImgUrl('accordion_title_06.png')" alt="禁止事項">
            </summary>
            <div class="c-jhs-free-lp-accordion-content">
                <p class="is-mgb16">
                    ▼本人確認書類の偽造、身分の偽りについて<br>
                    本人確認書類を偽造すること、また偽造されたこれら他人の本人確認書類を当社サービスの申込に際して提示することは、使用された証明書の種類により、有印公文書偽造罪（刑法155条1項）、同行使罪（刑法158条1項）、または有印私文書偽造罪（刑法159条1項）、同行使罪（刑法161条1項）が成立し、また本来有料であるはずの当社サービスの支払いを免れるものとして詐欺罪（刑法246条2項）が成立するなど、刑事犯罪を構成する場合があります。絶対にお止めください。
                </p>
                <p>
                    ▼プリ画の代行取得について<br>
                    第三者を代理して、ユーザー御本人以外の画像を取得する行為は禁止します。<br>
                    本人以外の画像を取得したことが発覚した場合<br>
                    ・ピクトリンク自体のご利用を制限する場合があります。<br>
                    ・プレミアム会員の権利を剥奪（はくだつ）する場合があります。<br>
                    ・無料化期間分のプレミアム会員料金を請求する場合があります。<br>
                    ・無料サービス全体が中止になる場合があります。
                </p>
            </div>
        </details>
        <details class="c-jhs-free-lp-accordion-item" :open="'open'">
            <summary class="c-jhs-free-lp-accordion-title c-jhs-free-lp-accordion-back_gray">
                <img :src="buildImgUrl('accordion_title_07.png')" alt="個人情報の取り扱い">
            </summary>
            <div class="c-jhs-free-lp-accordion-content">
                <p class="is-mgb8">
                    当社は、お客様の個人情報を本規約に定めるほか、以下のサービスプライバシーポリシーに基づき取り扱うものとします。<br>
                    <link-text :link="servicePolicyUrl" :new-window="true" :text="servicePolicyUrl" data-jest="appli-policy-link"/>
                </p>
                <p>
                    ※サービス向上のために、本サービス申込時にご入力頂いたメールアドレスにアンケートのご協力をお願いする可能性があります。
                </p>
            </div>
        </details>
        <details class="c-jhs-free-lp-accordion-item is-mgb16" :open="'open'">
            <summary class="c-jhs-free-lp-accordion-title c-jhs-free-lp-accordion-back_gray">
                <img :src="buildImgUrl('accordion_title_08.png')" alt="お問い合わせ">
            </summary>
            <div class="c-jhs-free-lp-accordion-content">
                <p>
                    ピクトリンク　カスタマーセンター<br>
                    お問い合わせフォーム<br>
                    <link-text :link="inquiryUrl" :new-window="true" :text="domain+inquiryUrl" data-jest="inquiry-link"/><br>
                    受付時間：平日9:30～11:45、12:30～17:00（土日祝日、会社特休日除く）
                </p>
            </div>
        </details>
        <p class="m-text-comments is-light">※QRコードは（株）デンソーウェーブの登録商標です。</p>
    </div>
</template>

<script>
import * as urlUtil from "../../util/UrlUtil"
import ListText from "../atoms/ListText.vue"
import LinkText from "../atoms/LinkText.vue";
import * as privacyPolicyAgreementAction from "../../model/action/PrivacyPolicyAgreementAction.js";
import {mapGetters} from "vuex";

export default {
    name: "JhsFreeLpAccordion",
    components: {ListText, LinkText},
    data() {
        return {
            domain: urlUtil.productUrlUtil.productDomain(),
            furyuUrl: urlUtil.productUrlUtil.furyuUrl(),
            operatingPolicyUrl: urlUtil.policyUrlUtil.operatingPolicyUrl(),
            privacyUrl: urlUtil.policyUrlUtil.privacyUrl(),
            helpTopUrl: urlUtil.helpUrlUtil.helpTopUrl("pictlink_web"),
            inquiryUrl: urlUtil.servletUrlUtil.inquiryInputUrl(''),
            servicePolicyUrl: null
        }
    },
    created() {
        this.setServicePolicyUrl()
    },
    computed: {
        ...mapGetters({
            accountStatus: 'AccountStoreV2/accountStatus',
        }),
        isAfter20260401() {
            return this.accountStatus.timeTripDate.isAfterTime("2026-04-01T00:00:00")
        },
    },
    methods: {
        /**
         * 画像のURLを組み立てる
         * @param {string} imgName 画像名
         */
        buildImgUrl(imgName) {
            return urlUtil.imageUrlUtil.buildS3ImageUrl('img/jhs-free/lp/' + imgName)
        },
        /**
         * cssのurl関数の呼び出し部分の含めた文字列を返す
         * styleタグ内でv-bindで使用することを想定している
         */
        buildStyleImgUrl(imageName) {
            const imgUrl = this.buildImgUrl(imageName)
            return `url(${imgUrl})`;
        },
        setServicePolicyUrl() {
            privacyPolicyAgreementAction.getPrivacyPolicyStatuses()
                .then(result => {
                    this.servicePolicyUrl = result.servicePolicy.url
                })
        },
    }
}
</script>

<style lang="scss" scoped>
@use "../../../scss/v2/base/variables";
@use "sass:math";

// ベースとなるデバイス幅
$grid-device-width: 375px;
// 余白
$grid-base: percentage(math.div(16px, $grid-device-width)); // 16px
$grid-consistent: $grid-base * 0.5; // 8px

@mixin accordion-icon {
    width: 24px;
    height: 24px;
    content: '';
    display: block;
    position: absolute;
    background-size: contain;
    right: $grid-base;
    top: 50%;
    margin-top: -12px;
    pointer-events: none;
}

.c-jhs-free-lp-accordion-heading {
    padding: 12px $grid-base;
    margin-bottom: 1px;
}
.c-jhs-free-lp-accordion {
    padding: $grid-consistent*3 $grid-base;
    margin-right: -$grid-consistent;
    margin-left: -$grid-consistent;
    background: variables.$color-offwhite;
    &-item {
        margin-bottom: 1px;
        // アコーディオンopen時
        &[open] {
            >.c-jhs-free-lp-accordion-title {
                &:after {
                    @include accordion-icon;
                    background: v-bind("buildStyleImgUrl('accordion_close.svg')") no-repeat center;
                }
            }
        }
    }
    &-back {
        &_gray {
            background: variables.$color-pictlink-black-30;
        }
        &_dark_gray {
            background-color: variables.$color-pictlink-black-50;
        }
    }
    &-title {
        display: block;
        padding: 12px $grid-base;
        position: relative;
        &::-webkit-details-marker {
            display: none;
        }
        &:after {
            @include accordion-icon;
            background: v-bind("buildStyleImgUrl('accordion_open.svg')") no-repeat center;
        }
    }

    &-content {
        padding: $grid-base;
        background-color: variables.$color-pictlink-black-10;
        p, span, .m-list-text-item{
            color: variables.$color-pictlink-black-50;
            font-size: 1.2rem;
        }
        :deep(.m-text-link) {
            color: variables.$color-jhs-free-link;
        }
    }
}

</style>
